module.exports = __webpack_public_path__ + "img/em_manutencao.09c27f63.png";